import {
    keepPreviousData,
    useInfiniteQuery,
} from '@tanstack/react-query'

import { requestBusinessObjects } from 'shared/services'
import { useJWTToken } from 'App/Auth'

const STATION_ADDRESS_MAIN_CATEGORY_NAME = 'STATION'
const PAGE_SIZE = 50

const getLocation = ({
    queryKey: [
        _key, // eslint-disable-line no-unused-vars
        {
            token,
            searchPhrase,
        },
    ],
    pageParam,
}) => {
    return requestBusinessObjects({
        method: 'POST',
        url: 'location/filter-request/all',
        data: {
            includeFilters: { addressMainCategory: [STATION_ADDRESS_MAIN_CATEGORY_NAME] },
            start: pageParam,
            rows: PAGE_SIZE,
            searchAll: searchPhrase || undefined,
            sortField: 'locationName',
            sortType: 'asc',
        },
        token,
    })
        .then((data) => {
            return data.data.items.map((location) => {
                return {
                    id: location.id,
                    name: location.locationName,
                }
            })
        })
}

const getNextPageParam = (lastPage, allPages) => {
    if (lastPage.length < PAGE_SIZE) {
        return undefined
    }

    return allPages.length * PAGE_SIZE
}

const flattenPages = (data) => {
    return data.pages.flat()
}

function useLocation(enabled = false, searchPhrase = '') {
    const token = useJWTToken()

    return useInfiniteQuery({
        queryKey: [
            'getServiceCenters',
            {
                token,
                searchPhrase,
            },
        ],
        queryFn: getLocation,
        initialPageParam: 0,
        getNextPageParam,
        select: flattenPages,
        placeholderData: keepPreviousData,
        enabled: Boolean(enabled),
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 1000,
    })
}

export default useLocation
